
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Gift, Users, DollarSign, TrendingUp, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useReferralSystem } from "@/hooks/use-referral-system";

export const ReferralQuickAction = () => {
  const navigate = useNavigate();
  const { referralCode, analytics, conversions } = useReferralSystem();

  // Calculate total earnings
  const totalEarnings = conversions?.reduce((sum, conv) => 
    conv.status === 'confirmed' ? sum + conv.commission_amount : sum, 0
  ) || 0;

  const totalClicks = analytics?.reduce((sum, month) => sum + month.total_clicks, 0) || 0;
  const totalConversions = analytics?.reduce((sum, month) => sum + month.total_conversions, 0) || 0;

  const handleGetStarted = () => {
    navigate('/referrals');
  };

  return (
    <Card className="bg-gradient-to-r from-green-50 to-emerald-50 border-green-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-green-800">
          <Gift className="h-5 w-5" />
          Referral Program
          <Badge variant="secondary" className="bg-orange-100 text-orange-800 text-xs">
            BETA
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Quick Stats */}
        <div className="grid grid-cols-3 gap-4">
          <div className="text-center">
            <div className="text-lg font-bold text-green-600">${totalEarnings.toFixed(2)}</div>
            <div className="text-xs text-green-700">Earned</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-bold text-green-600">{totalClicks}</div>
            <div className="text-xs text-green-700">Clicks</div>
          </div>
          <div className="text-center">
            <div className="text-lg font-bold text-green-600">{totalConversions}</div>
            <div className="text-xs text-green-700">Conversions</div>
          </div>
        </div>

        {/* Commission Structure */}
        <div className="bg-white rounded-lg p-3 border border-green-200">
          <div className="text-xs font-medium text-green-800 mb-2">Commission Rates:</div>
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div className="flex justify-between">
              <span className="text-gray-600">Monthly</span>
              <span className="font-semibold text-green-600">$5</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Team</span>
              <span className="font-semibold text-green-600">$20</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Enterprise</span>
              <span className="font-semibold text-green-600">$80</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Lifetime</span>
              <span className="font-semibold text-green-600">$175</span>
            </div>
          </div>
        </div>

        {/* Status and Action */}
        <div className="space-y-2">
          {referralCode ? (
            <div className="flex items-center justify-between">
              <Badge variant="outline" className="bg-green-100 text-green-800 border-green-300">
                Active Referrer
              </Badge>
              <Button 
                onClick={handleGetStarted}
                variant="outline"
                size="sm"
                className="text-green-600 border-green-300 hover:bg-green-50"
              >
                View Dashboard
                <ArrowRight className="h-3 w-3 ml-1" />
              </Button>
            </div>
          ) : (
            <Button 
              onClick={handleGetStarted}
              className="w-full bg-green-600 hover:bg-green-700"
            >
              <Gift className="h-4 w-4 mr-2" />
              Start Earning Today
            </Button>
          )}
        </div>

        <div className="text-xs text-green-600 text-center">
          Share CSO Agent and earn commissions on every referral
          <br />
          <span className="text-orange-600 font-medium">Beta Program - Terms may change</span>
        </div>
      </CardContent>
    </Card>
  );
};
